import { createFileRoute } from '@tanstack/react-router'
import { Dashboard } from 'pages/processData/Dashboard'

export const Route = createFileRoute('/process-data/$siteID/$dashboardID')({
  component: RouteComponent,
  staticData: {
    title: 'Process Data Dashboard',
    layout: {
      enableScrolling: true,
    },
  },
})

function RouteComponent() {
  return <Dashboard />
}
